export default __webpack_public_path__ + "static/media/stadisticsStand.ea06449e.svg";